module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Layout/Layout-grid-2ff6aae12754ab8f215f5e6fc1004022.svg";